import { render, staticRenderFns } from "./roles-inactive.component.html?vue&type=template&id=27322c28&scoped=true&"
import script from "./roles-inactive.component.ts?vue&type=script&lang=ts&"
export * from "./roles-inactive.component.ts?vue&type=script&lang=ts&"
import style0 from "./roles-inactive.component.scss?vue&type=style&index=0&id=27322c28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27322c28",
  null
  
)

export default component.exports